import { GridProps } from '@material-ui/core';
import ShippingIcon from '@material-ui/icons/LocalShipping';
import { FC } from 'react';
import { useHistory } from 'react-router';
import { ResourceAction, userIsAllowed } from '../../../Providers/AppPermissionsProvider';
import ShippingDatagrid from '../../../Resources/Shipping/ShippingDatagrid';
import { useDashboardContext } from '../../../hooks';
import AppDashboardCard from '../components/app-dashboard-card';
import AppDashboardTable from '../components/table/app-dashboard-table';

const AppDashboardShippings: FC<GridProps> = (gridProps) => {
  const history = useHistory();
  const { isIvg, user } = useDashboardContext();

  const allowView = userIsAllowed(ResourceAction.Get, 'shippings', user);

  if (isIvg || !allowView) return null;

  return (
    <AppDashboardCard {...gridProps}>
      <AppDashboardTable
        resource="shippings"
        tableTitle="Spedizioni"
        tableSubtitle="Di seguito sono elencate le spedizioni"
        noItemMessage="Non ci sono spedizioni da visualizzare"
        noItemIcon={<ShippingIcon />}
        rowClick={(id, basePath, record) =>
          history.push(
            `shippings/${record.id}?goBack=true&resourceLabel=dashboard&previousResourcePath=${location.pathname}`,
          )
        }
        sort={{ field: 'shippingDate', order: 'DESC' }}
        CustomDatagrid={<ShippingDatagrid rowClick={() => history.push('shippings')} />}
      />
    </AppDashboardCard>
  );
};

export default AppDashboardShippings;
